/*
 * @Author: git config user.name ShaoXuePeng
 * git config user.name 703491187@qq.com
 * @Date: 2022-04-08 12:01:28
 * @LastEditors: git config user.name ShaoXuePeng
 * git config user.name 703491187@qq.com
 * @LastEditTime: 2022-06-07 10:10:51
 * @FilePath: \YiTuYou\src\util\config.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
    // url: "https://yty.test.daqsoft.com/api/client/", //v2.0版本测试环境
    // url: "https://yty.smarttourisms.com/api",
    url: "https://yty.mssscbwg.com/api",
    maintenanceUrl: 'http://sscadm.mssscbwg.com',// 后期维护地址LW
    vcode: "a19f9aa84c74c14342f471f33806eecc",
    token: "2020020509350336632360AC62D7548C69FD071251100CA4A",
    uplocationTimer: 30 // 上传点位足迹时间间隔 单位秒
};
